module.exports = __webpack_public_path__ + "img/EPM102_1-1.2148c12d.jpg";